import { authApi } from '../api/authApi';
import { donateRecordsApi } from '../api/donateRecordsApi';
import { donateVariantsApi } from '../api/donateVariantsApi';
import { donatesApi } from '../api/donatesApi';
import { emotesApi } from '../api/emotesApi';
import { eventRecordsApi } from '../api/eventRecordsApi';
import { interactionsApi } from '../api/interactionsApi';
import { paymentOptionsApi } from '../api/paymentOptionsApi';
import { rouletteWidgetApi } from '../api/rouletteWidgetApi';
import { userApi } from '../api/userApi';
import { isAccountEndpoint } from '../api/accountRequestPolicy';

const privateEndpoints = (clientName, api) => Object.keys(api.endpoints)
  .filter((endpointName) => isAccountEndpoint(clientName, endpointName));

// Mixed API slices intentionally list only account-owned endpoints. Public
// username/token/widget queries remain warm when a session logs out.
export const ACCOUNT_API_ENDPOINTS = Object.freeze([
  {
    api: authApi,
    endpoints: [...privateEndpoints('authApi', authApi), 'logout']
  },
  { api: userApi, endpoints: privateEndpoints('userApi', userApi) },
  { api: donatesApi, endpoints: privateEndpoints('donatesApi', donatesApi) },
  { api: donateRecordsApi, endpoints: privateEndpoints('donateRecordsApi', donateRecordsApi) },
  { api: eventRecordsApi, endpoints: privateEndpoints('eventRecordsApi', eventRecordsApi) },
  { api: donateVariantsApi, endpoints: privateEndpoints('donateVariantsApi', donateVariantsApi) },
  { api: paymentOptionsApi, endpoints: privateEndpoints('paymentOptionsApi', paymentOptionsApi) },
  { api: rouletteWidgetApi, endpoints: privateEndpoints('rouletteWidgetApi', rouletteWidgetApi) },
  { api: emotesApi, endpoints: privateEndpoints('emotesApi', emotesApi) },
  { api: interactionsApi, endpoints: privateEndpoints('interactionsApi', interactionsApi) }
]);

const removeEndpointEntries = (dispatch, apiState, api, endpointNames) => {
  if (!apiState) {
    return;
  }

  const privateEndpoints = new Set(endpointNames);

  Object.entries(apiState.queries || {}).forEach(([queryCacheKey, entry]) => {
    if (privateEndpoints.has(entry?.endpointName)) {
      dispatch(api.internalActions.removeQueryResult({ queryCacheKey }));
    }
  });

  Object.entries(apiState.mutations || {}).forEach(([cacheKey, entry]) => {
    if (privateEndpoints.has(entry?.endpointName)) {
      dispatch(api.internalActions.removeMutationResult({
        requestId: entry.requestId || cacheKey,
        fixedCacheKey: entry.fixedCacheKey
      }));
    }
  });
};

export const resetAccountApiState = () => (dispatch, getState) => {
  const state = getState();

  ACCOUNT_API_ENDPOINTS.forEach(({ api, endpoints }) => {
    removeEndpointEntries(dispatch, state[api.reducerPath], api, endpoints);
  });
};
